import { render } from "./PriceCard.vue?vue&type=template&id=1a913820&scoped=true"
import script from "./PriceCard.vue?vue&type=script&lang=js"
export * from "./PriceCard.vue?vue&type=script&lang=js"

import "./PriceCard.vue?vue&type=style&index=0&id=1a913820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a913820"]])

export default __exports__